<template>
    <AdminBlock>
        <div class="row">
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label>
                                <strong>
                                    Invoice Dates
                                </strong>
                            </label>
                            <div class="input-daterange input-group">
                                <input v-model="filters.invoiceDateFrom" class="input-sm form-control js-flatpickers" name="invoice_start" value="" type="date">
                                <span class="input-group-addon">to</span>
                                <input v-model="filters.invoiceDateTo" class="input-sm form-control js-flatpickers" name="invoice_end" value="" type="date">
                            </div>
                        </div>
                    </div>
                    <div class="col-6"></div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-lg-6">
                        <CustomerSelect
                            v-model="filters.selectedCustomer"
                            :errors="[]"
                        />
                    </div>
                    <div class="col-lg-6">
                        <div class="row mb-4">
                            <label>
                                <strong>
                                    Sage Status
                                </strong>
                            </label>
                            <div class="checkbox checkbox-circle checkbox-primary">
                                <label for="checkbox-sage-all" title="all invoices regardless of sage status">
                                    <input v-model="filters.sageStatus" class="me-1" id="checkbox-sage-all" type="radio" name="sage" value="all" checked="checked" />
                                    All
                                </label>
                            </div>
                            <div class="checkbox checkbox-circle checkbox-primary">
                                <label for="checkbox-sage-exported" title="invoices that have been exported to sage">
                                    <input v-model="filters.sageStatus" class="me-1" id="checkbox-sage-exported" type="radio" name="sage" value="exported" />
                                    Exported
                                </label>
                            </div>
                            <div class="checkbox checkbox-circle checkbox-primary">
                                <label for="checkbox-sage-not_exported" title="invoices that have yet to be export">
                                    <input v-model="filters.sageStatus" class="me-1" id="checkbox-sage-not_exported" type="radio" name="sage" value="not_exported" />
                                    Not Yet Exported
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table
                ref="creditNoteTable"
                class="table table-bordered table-striped table-vcenter dataTable"
                id="datatable-credit-note-list"
                style="width: 100%;"
            >
                <thead>
                    <tr>
                        <th>Reference</th>
                        <th>Customer</th>
                        <th>Date</th>
                        <th>Total</th>
                        <th>Exported to Sage</th>
                        <th>Emailed to Customer</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </AdminBlock>

    <AdminBlock>
        <div class="row">
            <div class="d-flex justify-content-end">
                <div class="">
                    <form
                        method="POST"
                        :action="generateZipDownloadUrl()"
                    >
                        <input type="hidden" name="_token" :value="csrfToken" />
                        <input type="hidden" name="invoice_date_from" :value="filters.invoiceDateFrom || ''" />
                        <input type="hidden" name="invoice_date_to" :value="filters.invoiceDateTo || ''" />
                        <input type="hidden" name="customer_id" :value="filters.selectedCustomer ? filters.selectedCustomer.id : ''" />
                        <input type="hidden" name="sage_status" :value="filters.sageStatus || ''" />
                        <button type="submit" class="btn btn-secondary btn-sm">
                            Download These In A Zip
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </AdminBlock>

</template>

<script setup>
import { reactive, ref, watch, onMounted, onBeforeUnmount } from 'vue';
import CustomerSelect from '@/components/movements/components/CustomerSelect.vue';
import AdminBlock from '@/components/movements/components/AdminBlock.vue';

const filters = reactive({
    invoiceDateFrom: null,
    invoiceDateTo: null,
    selectedCustomer: null,
    sageStatus: 'all',
});

const generateAjaxUrl = () => route('api.movements.creditnotes.fetch');
const generateZipDownloadUrl = () => route('movements.creditnotes.download-zip');
const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

const creditNoteTable = ref(null);
let tableInstance = null;
let tableJQuery = null;

watch(
    filters,
    () => {
        if (tableInstance) {
            tableInstance.ajax.reload(null, false);
        }
    },
    { deep: true }
);

onMounted(() => {
    filters.sageStatus = 'all';

    if (!creditNoteTable.value) {
        return;
    }

    tableJQuery = window
        .jQuery(creditNoteTable.value)
        .on('preXhr.dt', (e, settings, data) => {
            data.filters = { ...filters };
        });

    tableInstance = tableJQuery.DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: generateAjaxUrl(),
        },
        order: [[0, 'desc']],
        columns: [
            {
                name: 'id',
                data: 'computed_reference',
                searchable: true,
                orderable: true,
            },
            {
                name: 'customer_id',
                data: 'computed_customer',
                searchable: true,
                orderable: true,
            },
            {
                name: 'created_at',
                data: 'created_at',
                searchable: true,
                orderable: true,
            },
            {
                name: 'computed_total',
                data: 'computed_total',
                searchable: true,
                orderable: true,
            },
            {
                name: 'exported_to_sage',
                data: 'exported_to_sage',
                searchable: true,
                orderable: true,
                render: (data, type, row) => (row.exported_to_sage ? 'Yes' : 'No'),
            },
            {
                name: 'last_emailed',
                data: 'last_emailed',
                searchable: true,
                orderable: true,
                render: (data, type, row) => (row.last_emailed ? 'Yes' : 'No'),
            },
            {
                name: 'computed_actions',
                data: 'computed_actions',
                searchable: false,
                orderable: false,
                width: '200px',
            },
        ],
    });
});

onBeforeUnmount(() => {
    if (tableJQuery) {
        tableJQuery.off('preXhr.dt');
        tableJQuery = null;
    }

    if (tableInstance) {
        tableInstance.destroy();
        tableInstance = null;
    }
});


</script>
